<template>
    <!-- :style="{backgroundImage:`url(${curbg})`}" -->
    <div id="app">
        <!-- 使用公共的头尾  目前就是登录注册的页面未使用公用的头尾  所以用登录二字判断-->
        <PageIndex v-if="$route.meta.title != '登录'">
            <template v-slot:main>
                <router-view></router-view>
            </template>
        </PageIndex>
        <!-- 不使用公共的头尾 -->
        <template v-else>
            <router-view></router-view>
        </template>
    </div>
</template>

<script>
import $ from "jquery";
import { f } from "./assets/js/index";
$(function () {
    +f();
    window.onresize = function () {
        f();
    };
});
import PageIndex from '@/layouts/index.vue'
export default {
    name: "App",
    components: {
        PageIndex
    },
    data() {
        return {
           
        };
    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                // console.log("=========", newVal.path);
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
    },
};
$(function () {
    //   alert('success');
});
</script>
<style lang="scss">
#wx_qrcode{width: 220px; height: 160px; margin: 0 auto;}
#wx_qrcode iframe{width: 100% !important; height: 100% !important; }
// @import "./style/sass";
::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.25);
    transition: color 0.2s ease;
}
</style>
<style>
@import url("./assets/css/reset");
@import url("./assets/font/iconfont");
#app {
    /* background: url(@/assets/images/index/bg.png) center center/cover no-repeat; */
}
table  th{ background-color: #F8F8F8 !important; color: #333 !important; font-weight: normal; }
.i_main{ min-height: 600px;}
.formConfirm .sbtn{ cursor: pointer;}
.cursor-pointer{cursor:pointer}
</style>
